import { Injectable, Type } from '@angular/core';

import { Product } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

import { BaseRestrictionCommand } from './base-restriction.command';
import { HideStatementsInlineComponent } from './components/hide-statements-inline/hide-statements-inline.component';
import { RestrictionCommandResult } from './restriction-command.interface';

@Injectable({ providedIn: 'root' })
export class HideStatementsCommand extends BaseRestrictionCommand {
  readonly type = 'hideStatements';
  readonly title = 'Не показывать выписки в ДБО';
  readonly icon = 'calendar';
  readonly isDangerous = false;
  readonly settingsNames = undefined;
  readonly group = 'visibility';
  readonly order = 3;
  readonly isInline = true; // Указываем, что это inline компонент
  readonly inlineComponent: Type<HideStatementsInlineComponent> = HideStatementsInlineComponent;

  constructor(commandAvailabilityService?: CommandAvailabilityService) {
    super(commandAvailabilityService);
  }

  /**
   * Команда должна быть disabled при запрете изменений (forbiddenChange)
   * hiddenExtract управляет состоянием toggle внутри inline-компонента
   */
  public isDisabled(context: { data: Product }): boolean {
    const product = context.data;

    return product.forbiddenChange === true || product.forbiddenChange === 'true';
  }

  async execute(_context: { data: Product }): Promise<RestrictionCommandResult> {
    // Для inline компонентов execute не вызывается
    // Логика реализована в самом компоненте
    return {
      success: false,
      shouldCloseParent: false
    };
  }
}
